import { createAppRequest } from '@/services/request';

const request = createAppRequest();
const WORKBENCH_PREFIX = '/bff/administration/workbench';

export interface WorkbenchModuleItem {
  key: string;
  name: string;
  path: string;
  description: string;
  icon?: string;
}

export interface WorkbenchOverviewData {
  announcements: {
    unreadCount: number;
    totalCount: number;
  };
  policies: {
    pendingConfirmCount: number;
    totalCount: number;
  };
  supplies: {
    pendingTaskCount: number;
    myApplyCount: number;
  };
  meetings: {
    todayCount: number;
    upcomingCount: number;
  };
  greenPlants: {
    pendingTaskCount: number;
    openIssueCount: number;
    totalPlacementCount: number;
  };
}

export interface WorkbenchTodoItem {
  id: string;
  sourceModule: 'announcement' | 'policy' | 'supplies' | 'meeting' | 'green_plant';
  sourceTitle: string;
  title: string;
  summary?: string;
  status?: string;
  time?: string;
  urgency?: 'normal' | 'urgent' | 'warning';
  actionUrl: string;
  actionText: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export async function getWorkbenchModules() {
  return request<ApiResponse<WorkbenchModuleItem[]>>(`${WORKBENCH_PREFIX}/modules`, {
    method: 'GET',
  });
}

export async function getWorkbenchOverview() {
  return request<ApiResponse<WorkbenchOverviewData>>(`${WORKBENCH_PREFIX}/overview`, {
    method: 'GET',
  });
}

export async function getWorkbenchTodos() {
  return request<ApiResponse<WorkbenchTodoItem[]>>(`${WORKBENCH_PREFIX}/todos`, {
    method: 'GET',
  });
}
